import React, { useState } from 'react'
import { Plus } from 'react-bootstrap-icons'
import GoalsList from '../../goals/list'
import userCurrentUser from '../../../hooks/use-current-user'
import NewButton from '../new-button'

const GoalsSection = ({
    userId,
}) => {
    const { id: currentUserId, isAdmin } = userCurrentUser()

    const renderNewButton = () => {
        if (!isAdmin && userId !== currentUserId ) {
            return null
        }
        return ( <NewButton variant='link'><Plus size={30} /></NewButton> )
    }

    return (
        <div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{
                    flexGrow: '1',
                    fontSize: '1.1em',
                    fontWeight: '700'
                }}>
                    GOALS
                </div>
                {renderNewButton()}
            </div>
            <div>
                <GoalsList userId={userId} />
            </div>
        </div>
    )
}

export default GoalsSection